import TagManager from 'react-gtm-module';
import ErrorLogger from '../services/errorlogger';
import { GTMInterface } from '../interfaces/gtminterface';
import { getAppInsights } from '../appInsights';

const GTMPushEvent = async (props: GTMInterface) => {

    fetch("/auth/GetGoogleTagKey")
        .then(async (response) => await response.json())
        .then((json) => {
            try {
                if (json.isGTMEnabled) {
                    const tagManagerArgs = {
                        gtmId: json.gtmKey,
                    };
                    TagManager.initialize(tagManagerArgs);
                    if (props.UserDetails?.usertype?.name) {
                        if (props.Path != undefined && props.Path != '') {
                            TagManager.dataLayer({
                                dataLayer: {
                                    event: 'pageview',
                                    page: {
                                        path: props.Path,
                                        title: props.PageName
                                    },
                                    'EventName': props.EventName,
                                    'ScreenName': props.PageName,
                                    //'LoginUser': UserEmail,
                                    'UserType': props.UserDetails?.usertype?.name,
                                    'Distributor': props.GlobalDropdown?.DistributorName ?? "",
                                    'Customer': props.GlobalDropdown?.CustomerName ?? "",
                                    'UserId': props.UserDetails?.id,
                                    // 'OrderId': OrderId,
                                    'Model': props.MachineDetails?.header?.model ?? "",
                                    'Serial': props.MachineDetails?.header?.serial ?? "",
                                    'ReferenceNumber': props.ReferenceNumber ?? ""
                                }
                            });
                        } else {
                            TagManager.dataLayer({
                                dataLayer: {
                                    'EventName': props.EventName,
                                    'ScreenName': props.PageName,
                                    //'LoginUser': UserEmail,
                                    'UserType': props.UserDetails?.usertype?.name,
                                    'Distributor': props.GlobalDropdown?.DistributorName ?? "",
                                    'Customer': props.GlobalDropdown?.CustomerName ?? "",
                                    'UserId': props.UserDetails?.id,
                                    // 'OrderId': OrderId,
                                    'Model': props.MachineDetails?.header?.model ?? "",
                                    'Serial': props.MachineDetails?.header?.serial ?? "",
                                    'ReferenceNumber': props.ReferenceNumber ?? ""
                                }
                            });
                        }
                    }
                   let Properties = {
                       'ScreenName': props.PageName,
                       'Distributor': props.GlobalDropdown?.DistributorName,
                       'Customer': props.GlobalDropdown?.CustomerName,
                       'Model': props.MachineDetails?.header?.model,
                       'Serial': props.MachineDetails?.header?.serial,
                       'ReferenceNumber': props.ReferenceNumber,
                       'UserEmail': props.UserDetails?.eml
                    }                  
                    getAppInsights().trackEvent({ name: props?.EventName }, Properties);
                }
            }
            catch (exception) {
                ErrorLogger(exception);
            }
        })

}

export default GTMPushEvent;